// Core
import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { BsArrowLeft } from 'react-icons/bs';
import theme from 'theme/theme.js';
import routes from 'routes.js';
import { Box, Image, Link, Flex, ChakraProvider, useColorModeValue } from '@chakra-ui/react';

export default function Pages(props) {
  const wrapper = React.createRef();
  React.useEffect(() => {
    document.body.style.overflow = 'unset';
    return function cleanup() {};
  });

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/auth') {
        if(prop.path !== '/login'){
          // setShowBackBtn(true);
        }
        return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
      } else {
        return null;
      }
    });
  };
  const navRef = React.useRef();
  document.documentElement.dir = 'ltr';

  const [page, setPage] = useState('login');
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/auth/forgot') {
      setPage('forgot');
    } else {
      setPage('login');
    }
  }, [location]);

  const backdropFilter = 'blur(30px)';

  const leftArrowColor = useColorModeValue('blue.920', 'blue.900');

  return (
    <ChakraProvider theme={theme} resetCss={false} w='100%'>
      <Box ref={navRef} w='100%'>
        <Box w='100%'>
          <Box ref={wrapper} w='100%'>
            <Flex position='relative' mb='0px' h={{base: '100vh'}}>
    		      <Flex
    		        h={{ base: '100%' }}
    		        w={{ base: '100%' }}
    		        maxW='1264px'
    		        mx='auto'
    		        justifyContent='space-between'
    		        mb='0px'
    		        pt={{ base: '0px' }}>
    		        <Flex
    		          alignItems='center'
    		          justifyContent='start'
    		          style={{ userSelect: 'none' }}
    		          w={{ base: '100%' }}
                  p={{base: '16px'}}>
                      <Switch>
                        {getRoutes(routes)}
                        <Redirect from='/auth' to='/auth/404' />
                      </Switch>
    			       </Flex>
		          </Flex>
            </Flex>
          </Box>
        </Box>
      </Box>
    </ChakraProvider>
  );
}